module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d653c2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/Select.vue
// module id = 541
// module chunks = 1